<template>
    <div class="flex-row">
        <el-input
            v-model="quantity"
            :min="parseInt(parameters.min_value)"
            :max="parseInt(parameters.max_value)"
            @blur="isFocus = false;"
            @focus="isFocus = true;"
            :controls="false">
        </el-input>
        <el-select v-model="value.unit_id" class="ml-2">
            <el-option v-for="unit in units" :key="unit.id" 
                :label="unit.label" 
                :value="parseInt(unit.id)">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import CfMixin from 'mixins/CustomfieldsMixins';
    import { createNamespacedHelpers } from 'vuex';

    const corp = createNamespacedHelpers('corp');

    export default {
        mixins: [CfMixin],
    
        data(){
            return {
                /**
                 * LocalValue is needed for format Quantity value and trigger store in same time
                 */
                localValue: {
                    number: null, 
                    userValue: null,
                    unit_id: null
                },
                isFocus: false,
                unitNumberFormat: {...window.App.numformat},
            }
        },


        computed: {
            ...corp.mapGetters([
                'units'
            ]),
            quantity: {
                get(){
                    this.localValue = {
                        ...this.localValue,
                        ...this.value,
                    };
                    if(this.value.number){
                        this.localValue.userValue = this.value.number
                    }
                    return this.isFocus ? this.localValue.userValue : NumberFormat.formatToDisplay(this.decimalValueFloat(this.localValue.userValue), this.unitNumberFormat, false);
                },
                set(quantity){
                    this.update(quantity)
                }

            }
        },

        methods: {
            /**
             * Returns the float value of decimalValue
             */
            decimalValueFloat(decimalValue) {
                return NumberFormat.formatToFloat(decimalValue, this.unitNumberFormat);
            },
            update(quantity){
                this.localValue.userValue = quantity;
                this.$emit('input', { id: this.id, value: {
                        number:  this.decimalValueFloat(quantity).toString(),
                        unit_id: this.value.unit_id
                    } 
                });
            }
        },

        watch: {
            '$store.state.corp.units': function() {
                if(!_.isNil(this.parameters.unit) && _.isNil(this.value.unit_id)) {
                    const unitId = this.units.find(unit => this.parameters.unit === unit.label).id;
                    this.$emit('input', { id: this.id, value: {
                            number:  this.decimalValueFloat(this.localValue.userValue).toString(),
                            unit_id: unitId
                        } 
                    });
                }
            }
        }

    }
</script>
